import axios from 'axios';

// Base API url
axios.defaults.baseURL = 'http://localhost:8000';

export default axios;
